module.exports = "<form #form=\"ngForm\">\r\n  <app-calculator></app-calculator>\r\n</form>\r\n"